const AddressActionsIcon = ({ onClick }) => (
  <button className="ms-auto flex h-8 w-4 items-center" onClick={onClick}>
    <span className="inline-flex items-center">
      {[...Array(3)].map((_, i) => (
        <span
          key={i}
          className="bg-supportiveMediumGray mx-px inline-block size-1 rounded-md"
        />
      ))}
    </span>
  </button>
);

export default AddressActionsIcon;
